import styled, { css } from 'styled-components'

import { ArrowIcon } from '@application/Interfaces/Icons'
import { Link } from '@src/Application/Interfaces/Atoms/Link'

export const Navbar = styled.div``

export const NavItem = styled.div<{ $expanded: boolean }>`
    padding: 16px;
    ${(props) => props.$expanded && `background-color: ${props.theme.color.p100}`}
`

const LinkStyled = css`
    ${(props) => props.theme.typo.bodyM};
    ${(props) => props.theme.fontWeight.medium};
    color: ${(props) => props.theme.color.g600};
    text-decoration: none;
`

export const NavItemLinkLabel = styled.div<{ $expanded: boolean }>`
    ${LinkStyled}
    cursor: pointer;

    ${(props) => props.$expanded && `color: ${props.theme.color.p500}`}
`

export const NavItemLink = styled(Link)`
    ${LinkStyled}
`

export const NavSubMenuLinkWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`

export const Arrow = styled(ArrowIcon)`
    cursor: pointer;
`

export const SubMenuWrapper = styled.div`
    padding-top: 24px;
    padding-left: 8px;
`

export const SectionTitle = styled.div`
    color: ${(props) => props.theme.color.g400};
    ${(props) => props.theme.typo.bodyXS}
    ${(props) => props.theme.fontWeight.regular};
    margin-bottom: 15px;
    text-transform: uppercase;
`
